import { IInput, IOTP } from 'app/services/api5-service/api.interface';
import { Observable, map } from 'rxjs';

import { matchMediaBreakpointDown$ } from 'common/media';

/**
 * Get width for input
 *
 * @param control
 */
export function getInputWidth$(
  control: IInput | IOTP,
): Observable<string | undefined> {
  return matchMediaBreakpointDown$('sm').pipe(
    map(isLessSm => (isLessSm ? '100%' : control.$width)),
  );
}
